import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { pickLang } from "./copy";
import { route } from "./paths";
import PageShell from "./pages/PageShell";
import HeroV2 from "./components/HeroV2";
import ManifestoV2 from "./components/ManifestoV2";
import ReelV2 from "./components/ReelV2";
import ServicesV2 from "./components/ServicesV2";
import ProcessV2 from "./components/ProcessV2";
import PricingV2 from "./components/PricingV2";
import ImpactV2 from "./components/ImpactV2";
import B2BV2 from "./components/B2BV2";
import FAQV2 from "./components/FAQV2";
import CTAV2 from "./components/CTAV2";

/**
 * Landing v2 — "Atelier".
 * Editorial redesign: ink & bone, serif display type, mono labels, tangerine
 * for action, teal as the brand's signature. Mounted at /:lang/v2; the
 * sub-pages live under /:lang/v2/*.
 */
const LandingV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);

  return (
    <PageShell
      seo={{
        title:
          lang === "fr"
            ? "Nettoyage de sneakers en Île-de-France dès 20€ | Lave Tes Baskets"
            : "Sneaker cleaning in Île-de-France from €20 | Lave Tes Baskets",
        description:
          lang === "fr"
            ? "Atelier de nettoyage de baskets : collecte et livraison à domicile, express 24h, imperméabilisation. Dès 20€ la paire, 5/5 sur Google, 500+ paires ravivées. Réservez en ligne."
            : "Sneaker cleaning atelier: home pickup and delivery, 24h express, waterproofing. From €20 per pair, 5/5 on Google, 500+ pairs revived. Book online.",
        canonicalPath: route(lang),
        ogImage: "/clean2.webp",
      }}
    >
      <HeroV2 />
      <ManifestoV2 />
      <ReelV2 />
      <ServicesV2 />
      <ProcessV2 />
      <PricingV2 />
      <ImpactV2 />
      <B2BV2 />
      <FAQV2 />
      <CTAV2 />
    </PageShell>
  );
};

export default LandingV2;
